<div class="flex flex-col flex-auto min-w-0">

    <!-- Header -->
    <div class="bg-card">
        <div class="flex flex-col w-full max-w-screen-xl mx-auto px-6 sm:px-8">
            <div class="flex flex-col sm:flex-row flex-auto sm:items-center min-w-0 my-8 sm:my-12">
                <!-- Avatar and name -->
                <div class="flex flex-auto items-center min-w-0">
                    <div class="flex flex-col min-w-0 ml-4">
                        <ng-container *transloco="let t">
                            <div class="text-2xl md:text-5xl font-semibold tracking-tight leading-7 md:leading-snug truncate">Clientes</div>
                        </ng-container>
                    </div>
                </div>
                <!-- Actions -->
                <div class="flex items-center mt-6 sm:mt-0 sm:ml-2 space-x-3">
                    <!-- <button
                        class="fuse-mat-button-rounded bg-accent-700"
                        mat-flat-button
                        [color]="'accent'">
                        <mat-icon
                            class="icon-size-5"
                            svgIcon="heroicons_solid:mail"></mat-icon>
                        <span class="ml-2">Messages</span>
                    </button> -->
                    <button
                        class="fuse-mat-button-rounded"
                        mat-flat-button
                        (click)="redirect('factura/nueva/0')"
                        [color]="'primary'">
                        <mat-icon
                            class="icon-size-5"
                            svgIcon="heroicons_solid:plus-circle"></mat-icon>
                        <span class="ml-2">Nuevo Cliente</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Main -->
    <div class="flex-auto border-t -mt-px pt-4 sm:pt-6">
        <div class="w-full max-w-screen-xl mx-auto">
            <!-- Tabs -->
            <mat-tab-group
                class="sm:px-2"
                [animationDuration]="'0'">

                <!-- Team -->
                <mat-tab label="Contratos">
                    <ng-template matTabContent>
                        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
                            <!-- Summary -->
                            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                                <div class="flex items-start justify-between">
                                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Folios</div>
                                    <div class="ml-2 -mt-2 -mr-3">
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="summaryMenu">
                                            <mat-icon
                                                class="icon-size-5"
                                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                                        </button>
                                        <mat-menu #summaryMenu="matMenu">
                                            <button mat-menu-item>Yesterday</button>
                                            <button mat-menu-item>2 days ago</button>
                                            <button mat-menu-item>3 days ago</button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center mt-2">
                                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-blue-500">21</div>
                                    <div class="text-lg font-medium text-blue-600 dark:text-blue-500">Disponibles</div>
                                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                                        <!-- <div class="text-md font-medium truncate">Completed:</div> -->
                                        <!-- <div class="ml-1.5 text-lg font-semibold">13</div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- Overdue -->
                            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                                <div class="flex items-start justify-between">
                                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Facturas</div>
                                    <div class="ml-2 -mt-2 -mr-3">
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="overdueMenu">
                                            <mat-icon
                                                class="icon-size-5"
                                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                                        </button>
                                        <mat-menu #overdueMenu="matMenu">
                                            <button mat-menu-item>Yesterday</button>
                                            <button mat-menu-item>2 days ago</button>
                                            <button mat-menu-item>3 days ago</button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center mt-2">
                                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-red-500">17</div>
                                    <div class="text-lg font-medium text-red-600 dark:text-red-500">Elaboradas</div>
                                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                                        <!-- <div class="text-md font-medium truncate">From yesterday:</div>
                                        <div class="ml-1.5 text-lg font-semibold">9</div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- Issues -->
                            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                                <div class="flex items-start justify-between">
                                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Cancelaciones</div>
                                    <div class="ml-2 -mt-2 -mr-3">
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="issuesMenu">
                                            <mat-icon
                                                class="icon-size-5"
                                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                                        </button>
                                        <mat-menu #issuesMenu="matMenu">
                                            <button mat-menu-item>Yesterday</button>
                                            <button mat-menu-item>2 days ago</button>
                                            <button mat-menu-item>3 days ago</button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center mt-2">
                                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-amber-500">39</div>
                                    <div class="text-lg font-medium text-amber-600 dark:text-amber-500">Elaboradas</div>
                                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                                        <!-- <div class="text-md font-medium truncate">Closed today:</div>
                                        <div class="ml-1.5 text-lg font-semibold">19</div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- Features -->
                            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                                <div class="flex items-start justify-between">
                                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Features</div>
                                    <div class="ml-2 -mt-2 -mr-3">
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="featuresMenu">
                                            <mat-icon
                                                class="icon-size-5"
                                                [svgIcon]="'heroicons_solid:dots-vertical'"></mat-icon>
                                        </button>
                                        <mat-menu #featuresMenu="matMenu">
                                            <button mat-menu-item>Yesterday</button>
                                            <button mat-menu-item>2 days ago</button>
                                            <button mat-menu-item>3 days ago</button>
                                        </mat-menu>
                                    </div>
                                </div>
                                <div class="flex flex-col items-center mt-2">
                                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-green-500">38</div>
                                    <div class="text-lg font-medium text-green-600 dark:text-green-500">Proposals</div>
                                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                                        <div class="text-md font-medium truncate">Implemented:</div>
                                        <div class="ml-1.5 text-lg font-semibold">16</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Github issues summary -->
                            <div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                                <div class="flex flex-col sm:flex-row items-start justify-between">
                                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Últimas 10 facturas</div>
                                    <div class="mt-3 sm:mt-0 sm:ml-2">
                                        <mat-button-toggle-group
                                            value="this-week"
                                            #githubIssuesWeekSelector="matButtonToggleGroup">
                                            <mat-button-toggle value="this-week">Consultar todas</mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </div>
                                </div>
                                <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                                    <table
                                        class="overflow-y-visible"
                                        mat-table
                                        [dataSource]="data?.rows">

                                        <!-- Type -->
                                        <ng-container
                                            matColumnDef="Nombre"
                                            sticky>
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef>
                                                Nombre
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let budget">
                                                <span class="flex items-center">
                                                    <span
                                                        class="w-2 h-2 rounded-full"
                                                        [ngClass]="{'bg-blue-500': true}"></span>
                                                    <span class="ml-3 leading-4">{{budget.nombre}}</span>
                                                </span>
                                            </td>
                                        </ng-container>

                                        <!-- Total -->
                                        <ng-container matColumnDef="Valor">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef>
                                                Valor
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let budget">
                                                <span class="font-medium text-right">
                                                    {{budget.valor}}
                                                </span>
                                            </td>
                                        </ng-container>

                                        <!-- Expenses amount -->
                                        <ng-container matColumnDef="Opciones">
                                            <th
                                                mat-header-cell
                                                *matHeaderCellDef class="text-right">
                                                Opciones
                                            </th>
                                            <td
                                                mat-cell
                                                *matCellDef="let budget" class="text-right">

                                                <ng-container *ngIf="idPadre == 0">
                                                    <button mat-stroked-button color="accent" (click)="getDataDetalle( budget )"><small>Ver catálogo</small></button>
                                                </ng-container>

                                                <ng-container *ngIf="idPadre != 0">
                                                    <button mat-stroked-button color="accent" (click)="openEditar( budget )"><small>Editar</small></button>
                                                    <button mat-stroked-button color="accent" (click)="PostDelCatalogos( budget.idCatalogo )"><small>Eliminar</small></button>
                                                </ng-container>


                                            </td>
                                        </ng-container>

                                        <tr
                                            mat-header-row
                                            *matHeaderRowDef="data?.columns"></tr>
                                        <tr
                                            mat-row
                                            *matRowDef="let row; columns: data?.columns;"></tr>
                                    </table>

                                    <div *ngIf="data?.rows.length === 0">
                                        <div class="alert alert-primary" role="alert">
                                            <small>Aún no hay registros</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Budget details -->
                            <!-- <div class="sm:col-span-6 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden" *ngIf="formModo == 1">
                                <div class="text-lg font-medium tracking-tight leading-6 truncate">Lista de catalogos</div>
                                <div class="flex flex-col flex-auto mt-2 overflow-x-auto">

                                </div>
                            </div> -->

                            <!-- <button mat-raised-button color="primary" (click)="redirect('cuenta/perfil')">Perfil</button>
                            <button mat-raised-button color="primary" (click)="redirect('cuenta/paquetes')">Paquetes</button> -->
                            <!-- <button (click)="redirect()">Perfil</button> -->
                        </div>
                    </ng-template>
                </mat-tab>

            </mat-tab-group>
        </div>
    </div>
</div>
